// extracted by mini-css-extract-plugin
export default {"image":"L0-z","loaded":"M0-z","placeholder":"N0-z"};